import { render, staticRenderFns } from "./FormKnowledgeDetail.vue?vue&type=template&id=575a3417&scoped=true&"
import script from "./FormKnowledgeDetail.vue?vue&type=script&lang=js&"
export * from "./FormKnowledgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormKnowledgeDetail.vue?vue&type=style&index=0&id=575a3417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a3417",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575a3417')) {
      api.createRecord('575a3417', component.options)
    } else {
      api.reload('575a3417', component.options)
    }
    module.hot.accept("./FormKnowledgeDetail.vue?vue&type=template&id=575a3417&scoped=true&", function () {
      api.rerender('575a3417', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/knowledge/FormKnowledgeDetail.vue"
export default component.exports